var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-412.954 -742.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.165 756.155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.733,300c-9.549,0-17.293,10.47-17.293,10.47s7.74,10.47,17.289,10.47,17.289-10.47,17.289-10.47S133.282,300,123.733,300Zm-.067,18.608a8.138,8.138,0,1,1,8.137-8.138,8.138,8.138,0,0,1-8.137,8.138Z",
    transform: "translate(-106.44 -296.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.346,481.293A4.293,4.293,0,1,1,481.053,477a4.293,4.293,0,0,1,4.293,4.293",
    transform: "translate(-463.836 -467.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.91,233.128l26.209-26.208L234.6,208.4l-26.208,26.209Z",
    transform: "translate(-203.404 -206.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.488,0A27.5,27.5,0,1,1,8.052,8.054,27.5,27.5,0,0,1,27.488,0ZM43.751,11.226a23.006,23.006,0,1,0,6.711,16.264,23.006,23.006,0,0,0-6.711-16.264Z",
    transform: "translate(412.957 742.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType3);
export default __webpack_public_path__ + "static/media/aioa-icon-type-3.2f5e91a2da4dc70830ac8251b5d11fa7.svg";
export { ForwardRef as ReactComponent };